import { AxiosResponse } from 'axios';
import qs from 'qs';

import { PermissionNames } from '~/constants/permissionNames';
import { RecipientDetailed } from '~/domain/model';
import { IFileExportResponse } from '~/domain/model/PriceReport/FileExport';
import { IPriceReportFilterParameters } from '~/domain/model/PriceReport/PriceReportFilterParameters';
import {
  IPriceReport,
  IPagedPriceReportParams,
  ISiteIdParams
} from '~/domain/model/PriceReport/PriceReportService';
import { ISalesChannel } from '~/domain/model/PriceReport/SaleChannel';
import api, { apiReport } from '~/services/api';
import {
  getProductCategories as getProductCategoriesByPermission,
  getProductGroups as getProductGroupsByPermission,
  getProductsSimple as getProductsSimpleByPermission
} from '~/services/producer/ProductFilter/ProductFilterService';

type Params = {
  [key: string]: unknown;
};

const paramsSerializer = <T extends Params>(params: T) =>
  qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true });

const permissionName = PermissionNames.Reports.MenuPriceReport;

export async function getSaleChannels() {
  return api.get<void, AxiosResponse<ISalesChannel[]>>('/sales-channels');
}

export const getProductCategories = (params: ISiteIdParams) =>
  getProductCategoriesByPermission(params, permissionName);

export const getProductGroups = (params: ISiteIdParams) =>
  getProductGroupsByPermission(params, permissionName);

export const getProductsSimple = (params: ISiteIdParams) =>
  getProductsSimpleByPermission(params, permissionName);

export const getProductRecipients = (params: ISiteIdParams) => {
  return api.get<void, AxiosResponse<RecipientDetailed[]>>(
    '/product/recipients/by-site-ids',
    {
      params,
      paramsSerializer
    }
  );
};

export async function getExcelExport(params: IPriceReportFilterParameters) {
  return apiReport.post<void, AxiosResponse<IFileExportResponse>>(
    '/price-report/export',
    params
  );
}

export async function getGroupedExcelExport(
  params: IPriceReportFilterParameters
) {
  return apiReport.post<void, AxiosResponse<IFileExportResponse>>(
    '/price-report/export/grouped-by-sale-channel',
    params
  );
}

export async function getListPriceReports(
  params: IPagedPriceReportParams
): Promise<AxiosResponse<IPriceReport>> {
  return apiReport.post<void, AxiosResponse<IPriceReport>>(
    '/price-report',
    params
  );
}

export async function getGroupedListPriceReports(
  params: IPagedPriceReportParams
): Promise<AxiosResponse<IPriceReport>> {
  return apiReport.post<void, AxiosResponse<IPriceReport>>(
    '/price-report/grouped-by-sale-channel',
    params
  );
}
